import React from "react";

const HomeMetrics = () => {
  const metrics = [
    { value: "150M+", label: "AI Tokens Processed / Mo" },
    { value: "10K+", label: "Daily Autonomous Executions" },
    { value: "99.9%", label: "Uptime & SLA Guarantee" },
    { value: "Secure", label: "SOC2 Compliant VPC Nodes" }
  ];

  return (
    <section className="py-16 px-6 max-w-7xl mx-auto text-zinc-800 dark:text-zinc-200">
      <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-zinc-900 dark:text-white leading-tight">
          Unfair advantages, powered by JL
        </h2>
        <p className="text-zinc-500 dark:text-zinc-400 text-sm sm:text-base font-light leading-relaxed">
          We substitute guesswork with data. Jibu Labs synthesizes high-throughput ML pipelines, private corporate databases, and real-time computation logs to give you an objective, predictive roadmap for model scaling.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((m, idx) => (
          <div 
            key={idx} 
            className="flex flex-col justify-between p-8 bg-zinc-900 text-white rounded-[24px] border border-zinc-800 hover:border-forest/40 transition-all duration-300 relative overflow-hidden"
          >
            {/* Background Graphic Lines */}
            <div className="absolute inset-x-0 bottom-0 h-12 opacity-5 pointer-events-none bg-gradient-to-t from-forest to-transparent"></div>
            
            <div className="space-y-4 relative z-10">
              <span className="text-4xl sm:text-5xl font-black text-white block">
                {m.value}
              </span>
              <span className="text-xs text-zinc-400 font-light block leading-normal">
                {m.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeMetrics;
